import { memo } from 'react';
import CardHeader from '@mui/material/CardHeader';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
//Local styles
import { CardStyled } from './MessagesSkeleton.styled';

const ContentSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <CardStyled>
        <CardHeader
          title={
            <Skeleton
              animation="wave"
              height={10}
              width="80%"
              style={{ marginBottom: 6 }}
            />
          }
          subheader={<Skeleton animation="wave" height={10} width="40%" />}
        />
      </CardStyled> 
      <CardStyled sx={{ marginLeft: '50%' }}>
        <CardHeader
          title={
            <Skeleton
              animation="wave"
              height={10}
              width="80%"
              style={{ marginBottom: 6 }}
            />
          }
          subheader={<Skeleton animation="wave" height={10} width="40%" />}
        />
      </CardStyled> 
      <CardStyled>
        <CardHeader
          title={
            <Skeleton
              animation="wave"
              height={10}
              width="80%"
              style={{ marginBottom: 6 }}
            />
          }
          subheader={<Skeleton animation="wave" height={10} width="40%" />}
        />
      </CardStyled> 
      <CardStyled sx={{ marginLeft: '50%' }}>
        <CardHeader
          title={
            <Skeleton
              animation="wave"
              height={10}
              width="80%"
              style={{ marginBottom: 6 }}
            />
          }
          subheader={<Skeleton animation="wave" height={10} width="40%" />}
        />
      </CardStyled> 
      <CardStyled>
        <CardHeader
          title={
            <Skeleton
              animation="wave"
              height={10}
              width="80%"
              style={{ marginBottom: 6 }}
            />
          }
          subheader={<Skeleton animation="wave" height={10} width="40%" />}
        />
      </CardStyled> 
    </Box>
  )
};

export default memo(ContentSkeleton);